// safeLinkAddress accepts the addresses an editor links to: http(s) and
// mailto. A bare domain gets https, and with { email: true } a bare email
// address gets mailto. Anything else, javascript: included, returns "".
//
// The address comes back as typed, not re-serialised by URL, so a merge
// tag such as {{first_name}} inside it survives unencoded. The server's
// sanitiser is still the authoritative gate; this keeps the editor from
// offering what the server would drop.
export function safeLinkAddress(raw, { email = false } = {}) {
  const value = (raw || "").trim();
  if (!value || /\s/.test(value)) return "";

  let candidate = value;
  if (email && /^[^@/:]+@[^@/:]+\.[^@/:]+$/.test(value)) {
    candidate = `mailto:${value}`;
  } else if (!/^[a-z][a-z0-9+.-]*:/i.test(value)) {
    candidate = `https://${value}`;
  }

  let url;
  try {
    url = new URL(candidate);
  } catch (_) {
    return "";
  }

  return ["http:", "https:", "mailto:"].includes(url.protocol.toLowerCase())
    ? candidate
    : "";
}
